"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = exports.write = void 0;
var diveSplatters_sidecar_1 = require("@dive/effects/diveSplatters-sidecar");
var diveEnums_1 = require("@dive/enums/diveEnums");
var diveStringSaver_sidecar_1 = require("./diveStringSaver-sidecar");
var version = 'v0.1.1';
var namespace = 'splatters';
var item = 'splatter';
function write() {
    var e_1, _a;
    diveStringSaver_sidecar_1.diveStringSaver.wHeader(namespace, version);
    var objs = diveSplatters_sidecar_1.diveSplatters.getAll();
    try {
        for (var objs_1 = __values(objs), objs_1_1 = objs_1.next(); !objs_1_1.done; objs_1_1 = objs_1.next()) {
            var c = objs_1_1.value;
            if (c.isDead) {
                continue;
            }
            diveStringSaver_sidecar_1.diveStringSaver.wString(item);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.id);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.splatterIdx);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.i);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.j);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.x);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.y);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.flipX);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.flipY);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.tint);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objs_1_1 && !objs_1_1.done && (_a = objs_1.return)) _a.call(objs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    diveStringSaver_sidecar_1.diveStringSaver.wEnd(namespace);
}
exports.write = write;
function read() {
    diveStringSaver_sidecar_1.diveStringSaver.rHeader(namespace, version);
    diveSplatters_sidecar_1.diveSplatters.killAll();
    while (diveStringSaver_sidecar_1.diveStringSaver.rPeek(item)) {
        diveStringSaver_sidecar_1.diveStringSaver.rString(item);
        var id = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var splatterIdx = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var i = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var j = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var x = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var y = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var flipX = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var flipY = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var tint = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var c = diveSplatters_sidecar_1.diveSplatters.create(id, diveEnums_1.EDiveSplatterType.Any, i, j, x, y, tint);
        c.splatterIdx = splatterIdx;
        c.flipX = flipX;
        c.flipY = flipY;
    }
    diveStringSaver_sidecar_1.diveStringSaver.rEnd(namespace);
}
exports.read = read;
